import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import CareerDetail from "@/pages/CareerDetail";
import Report from "@/pages/Report";
import PaymentReturn from "@/pages/PaymentReturn";
import { LangProvider } from "@/i18n";
import { ReviewLayer } from "@/components/ReviewLayer";
import TranslationReview from "@/pages/TranslationReview";
import SignInPage from "@/pages/SignInPage";
import Thanks from "@/pages/Thanks";
import ExploreCareers from "@/pages/ExploreCareers";
import CompareCareers from "@/pages/CompareCareers";
import { CompareBar } from "@/components/CompareBar";
import { LanguageHint } from "@/components/LanguageHint";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { SignUp } from "@clerk/react";

const Auth = ({ children }) => <ClerkAuthProvider>{children}</ClerkAuthProvider>;

function App() {
  return (
    <LangProvider>
    <div className="App paper-grain">
      <BrowserRouter>
        <LanguageHint />
        <SiteHeader />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/results/:token" element={<Results />} />
            <Route path="/results/:token/career/:careerId" element={<CareerDetail />} />
            <Route path="/results/:token/report" element={<Report />} />
            <Route path="/payment/success" element={<PaymentReturn />} />
            <Route path="/payment/cancel" element={<PaymentReturn cancelled />} />
            <Route path="/translations/review" element={<Auth><TranslationReview /></Auth>} />
            <Route path="/thanks" element={<Thanks />} />
            <Route path="/careers" element={<ExploreCareers />} />
            <Route path="/careers/compare" element={<CompareCareers />} />
            <Route path="/careers/:careerId" element={<CareerDetail />} />
            <Route path="/sign-in/*" element={<Auth><SignInPage /></Auth>} />
            <Route path="/sign-up/*" element={<Auth><div className="min-h-[70vh] flex items-center justify-center px-4 py-10" data-no-translate><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></div></Auth>} />
          </Routes>
        </main>
        <SiteFooter />
        <CompareBar />
        <Toaster position="bottom-right" />
        <ReviewLayer />
      </BrowserRouter>
    </div>
    </LangProvider>
  );
}

export default App;
